<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading" v-if="warehouse.id">
        {{ $t('warehouse.edit') }}
      </div>
      <div class="content-heading" v-else>
        {{ $t('warehouse.add') }}
      </div>
      <div class="row">
        <div class="col-xl-4">
          <div class="card card-default">
            <div class="card-body">
              <form @submit.prevent="save" class="form-modal form-warehouse">

                <div class="form-group">
                  <label for="name">{{ $t('warehouse.name') }} *</label>
                  <input
                    :class="{'parsley-error': errors.name}"
                    autocomplete="off"
                    class="form-control"
                    id="name"
                    :placeholder="$t('warehouse.insert-name')"
                    type="text"
                    disabled="disabled"
                    v-model="warehouse.name">
                  <ul class="parsley-errors-list filled" v-if="errors.name">
                    <li class="parsley-required">{{ errors.name[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label>{{ $t('warehouse.group') }} *</label>
                  <multiselect
                    :options="groups"
                    id="group"
                    label="name"
                    :placeholder="$t('warehouse.select-group')"
                    track-by="id"
                    v-model="warehouse.group">
                    <template slot="noOptions">{{ $t('global.no-options') }}</template>
                  </multiselect>
                  <ul class="parsley-errors-list filled" v-if="errors.group">
                    <li class="parsley-required">{{ errors.group[0] }}</li>
                  </ul>
                </div>

                <buttons url="warehouses"/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import Buttons from '@/components/Buttons.vue'
import message from '@/message'
import More from '@/components/More.vue'
import Multiselect from 'vue-multiselect'
import {parseApiError} from '@/utils'

const getData = (id, next) => {
  if (id) {
    Promise.all([
      api.get(`/warehouses/${id}/`),
      api.get('/groups/?is_active=true&page_size=100')
    ])
      .then(([warehouse, group]) => {
        warehouse.data.group = {
          'id': warehouse.data.group,
          'name': warehouse.data.group_name
        }
        next({
          warehouse: warehouse.data,
          groups: group.data.results
        })
      })
  } else {
    Promise.all([
      api.get('/groups/?is_active=true&page_size=100')
    ])
      .then(([groups]) => {
        next({
          warehouse: {
            name: '',
            description: '',
            address: '',
            group: null,
            code: '',
            is_active: true
          },
          groups: groups.data.results
        })
      })
  }
}

export default {
  components: {
    buttons: Buttons,
    more: More,
    Multiselect
  },
  data () {
    return {
      warehouse: {},
      groups: [],
      more: null,
      errors: {}
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    }
  },
  mounted () {
    this.$parent.menu = 'setup'
    this.$parent.submenu = 'warehouses'
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    save () {
      this.errors = {}

      let data = {
        id: this.warehouse.id,
        name: this.warehouse.name,
        group: this.warehouse.group ? this.warehouse.group.id : null
      }

      if (data.id) {
        api.patch(`/warehouses/${data.id}/`, data)
          .then(() => {
            message.success(this.$i18n.t('warehouse.changed'))
            this.$router.push({name: 'warehouses'})
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
      } else {
        api.post('/warehouses/', data)
          .then(() => {
            message.success(this.$i18n.t('warehouse.added'))
            if (this.more) {
              this.warehouse.name = ''
              this.warehouse.description = ''
              this.warehouse.address = ''
              this.warehouse.group = null
              this.warehouse.is_active = true
              this.warehouse.code = ''
              this.$router.push({name: 'warehouse_add'})
            } else {
              this.$router.push({name: 'warehouses'})
            }
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to.params.id, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to.params.id, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Warehouse.vue